export default "__VITE_ASSET__xoRbp1ZY__"